import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

/**
 * Displays a paginator for DataTables but not affect to URL.
 * Only used for Executive Report Survey List
 * Inspired by https://www.primefaces.org/primereact/#/paginator
 */
class ManagementListPaginator extends Component {
  static propTypes = {
    pageInfo: PropTypes.shape({
      hasPreviousPage: PropTypes.bool,
      hasNextPage: PropTypes.bool,
      startCursor: PropTypes.string,
      endCursor: PropTypes.string,
    }).isRequired,
    totalCount: PropTypes.number.isRequired,
    indexFrom: PropTypes.number,
    indexTo: PropTypes.number,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
    search: PropTypes.objectOf(PropTypes.any).isRequired,
    changePageSize: PropTypes.func.isRequired,
    movePrev: PropTypes.func.isRequired,
    moveNext: PropTypes.func.isRequired,
  };

  static defaultProps = {
    rowsPerPageOptions: [25, 50, 100],
    indexFrom: 0,
    indexTo: 0,
  };

  render() {
    const {
      pageInfo, totalCount, indexFrom, indexTo,
      rowsPerPageOptions,
      search,
      changePageSize,
      movePrev,
      moveNext,
    } = this.props;
    const { pageSize } = search;
    const {
      hasPreviousPage, hasNextPage, startCursor, endCursor,
    } = pageInfo;

    const rowsPerPage = rowsPerPageOptions.map(value => ({ label: value, value }));

    return (
      <div>
        <Button
          icon="pi pi-caret-left"
          disabled={!hasPreviousPage}
          onClick={() => movePrev(startCursor)}
        />
        <span>{` ${indexFrom} - ${indexTo} / ${totalCount} `}</span>
        <Button
          icon="pi pi-caret-right"
          disabled={!hasNextPage}
          onClick={() => moveNext(endCursor)}
        />
        <Dropdown
          value={parseInt(pageSize, 10)}
          options={rowsPerPage}
          onChange={changePageSize}
        />
      </div>
    );
  }
}

export default withRouter(ManagementListPaginator);
